<template>
  <a
    :href="bookLink"
    target="__blank"
    class="button-order"
  >
    <span class="content">
      <slot />
    </span>
  </a>
</template>

<script>
import { LANGUAGE_MAP } from '../../../constants';

const MOZIO_APP_URL = process.env.VUE_APP_MOZIO_APP_ENDPOINT;
const buildGetParams = params => Object.keys(params)
  .reduce((acc, key, index) => {
    acc += index === 0 ? `?${key}=${params[key]}` : `&${key}=${params[key]}`;
    return acc;
  }, '');
const getBookLink = (locale, qParam) => `${MOZIO_APP_URL}/${locale}/book${buildGetParams(qParam)}`;

export default {
  name: 'ButtonOrder',
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    tripId: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: false,
      default: 'en',
    },
  },
  computed: {
    bookLink() {
      return getBookLink(LANGUAGE_MAP[this.locale].app, {
        session_id: this.sessionId,
        trip_id: this.tripId,
        currency: this.currency,
        ref: 'kiwitaxi',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .button-order {
    border-radius: 3px;
    background-color: #468cc8;
    padding: 13px;
    width: 100%;
    // display: inline-block;
    text-decoration: none;
    box-sizing: border-box;
    text-align: center;
    @media screen and (min-width: $tablet-width) {
      display: inline;
      position: absolute;
      right: 0;
      width: auto;
      bottom: 0;
    }

    &:hover {
      text-decoration: none;
    }
  }

  .content {
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
    color: #fff;
    height: 48px;
    white-space: nowrap;
  }
</style>
